// import React from 'react';

// import classes from './SidebarEntry.scss';

const sidebarEntry = (props) => {
  return props.render(props);
}

export default sidebarEntry;